import { get } from "lib/fetch";

export const GET_ALIGNMENT_RESULTS = "alignmentResults/GET";

export const getAlignmentResults = (subjectId: number, templateId: number, ruleId?: number | null) => ({
  type: GET_ALIGNMENT_RESULTS,
  payload: ruleId
    ? get(`/v1/site/${subjectId}/align/${templateId}?version=${ruleId}`)
    : get(`/v1/site/${subjectId}/align/${templateId}`),
});
